import * as React from "react"
import {Stack, Divider} from "@mui/material";
import MaximalLayoutNavMiniNavList from "./NavList";


export default function MaximalLayoutNavSectionMini({ routes, sx={} }) {

    return <Stack spacing={0.5} alignItems="center" sx={{ px: 0.75, py: 0.3 }}>
        { routes.map( ({ path, index, children, ...config }, idx) => {
            if (index) return null

            if (path === 'divider') {
                return <Divider key={`${path}-${idx}`} sx={{ width: '80%', my: 1 }} />
            }

            return <MaximalLayoutNavMiniNavList key={`${path}-${idx}`} path={path} routes={children} sx={sx} {...config} />
        }) }
    </Stack>
}